var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      staticClass: "page",
      attrs: { title: _vm.$t("Webheader.rtp_global_settings"), colWidth: "6" },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _vm.canSeeSRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  inputType: "text",
                                  inputLabel: _vm.$t(
                                    "administration.rtp_identifier"
                                  ),
                                  horizontal: "",
                                },
                                model: {
                                  value: _vm.settings.RTPSPIdentifier,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "RTPSPIdentifier",
                                      $$v
                                    )
                                  },
                                  expression: "settings.RTPSPIdentifier",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canSeeSRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                staticClass: "justify-content-around",
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  maxLength: 21,
                                  inputType: "number",
                                  inputLabel: _vm.$t("settings.max_amnt_srtp"),
                                  horizontal: "",
                                },
                                on: { blur: _vm.changeMaxAmountSRTP },
                                model: {
                                  value: _vm.settings["SRTP-RTPSPMaxAmount"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "SRTP-RTPSPMaxAmount",
                                      $$v
                                    )
                                  },
                                  expression: "settings['SRTP-RTPSPMaxAmount']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canSeeSRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  maxLength: 21,
                                  inputType: "number",
                                  inputLabel: _vm.$t(
                                    "administration.rtp_time_before_expiration"
                                  ),
                                  horizontal: "",
                                },
                                on: { blur: _vm.changeTimeBeforeExpSRTP },
                                model: {
                                  value: _vm.settings.RTPSPTimeBeforeExpiration,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "RTPSPTimeBeforeExpiration",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.RTPSPTimeBeforeExpiration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canSeeHRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  inputType: "text",
                                  inputLabel: _vm.$t(
                                    "administration.hrtp_identifier"
                                  ),
                                  horizontal: "",
                                },
                                model: {
                                  value: _vm.settings["HRTP-Identifier"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "HRTP-Identifier",
                                      $$v
                                    )
                                  },
                                  expression: "settings['HRTP-Identifier']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canSeeHRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                staticClass: "justify-content-around",
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  maxLength: 21,
                                  inputType: "number",
                                  inputLabel: _vm.$t("settings.max_amnt_hrtp"),
                                  horizontal: "",
                                },
                                on: { blur: _vm.changeMaxAmountHRTP },
                                model: {
                                  value: _vm.settings["HRTP-RTPSPMaxAmount"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "HRTP-RTPSPMaxAmount",
                                      $$v
                                    )
                                  },
                                  expression: "settings['HRTP-RTPSPMaxAmount']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canSeeHRTP
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", lg: "10", offset: "1" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: !_vm.doesEdit,
                                  maxLength: 21,
                                  inputType: "text",
                                  inputLabel: _vm.$t(
                                    "administration.rtp_h_validity_period"
                                  ),
                                  horizontal: "",
                                },
                                on: { blur: _vm.changeVldityPeriodHRTP },
                                model: {
                                  value: _vm.settings["HRTP-ValidityPeriod"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "HRTP-ValidityPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "settings['HRTP-ValidityPeriod']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
          _vm._v(" "),
          _vm.hasRight("application_global_rtp_settings_editer")
            ? _c(
                "div",
                { staticClass: "col-md-10 offset-md-1" },
                [
                  !_vm.doesEdit
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.editSettings },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("administration.edit"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.resetSettings },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.cncl"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSettings(_vm.settings)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.update"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }